<script>
  import { format } from 'svelte-i18n';
  import { FormGroup, Input, Label } from '@sveltestrap/sveltestrap';

  import { companyName, companyUrl } from '@client/stores/brand';
</script>

<header>
  <h2>{$format('label.BRAND_WIZARD_STEP_INTRO')}</h2>
  <p class="mb-4">{$format('label.BRAND_WIZARD_STEP_INTRO_DESCRIPTION')}</p>
</header>

<FormGroup>
  <Label for="brand">{$format('label.COMPANY_NAME')}</Label>
  <Input bind:value={$companyName} />
</FormGroup>

<FormGroup>
  <Label for="brand">{$format('label.COMPANY_URL')}</Label>
  <Input bind:value={$companyUrl} />
</FormGroup>
